"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var menuModule = require('./Menu.module.scss');
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Cores_1 = require("../../Cores/Cores");
var MenuItem_1 = require("../MenuSuspenso/MenuItem/MenuItem");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Botao_1 = require("../../Botao/Botao");
var Icone_1 = require("../../Icone/Icone");
var Menu = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'menu' : _b, _c = _a.itensSelecionados, itensSelecionados = _c === void 0 ? [] : _c, classes = _a.classes, _d = _a.variante, variante = _d === void 0 ? 'normal' : _d, tituloCabecalho = _a.tituloCabecalho, _e = _a.tipoDoMenu, tipoDoMenu = _e === void 0 ? 'actions' : _e, _f = _a.posicaoDoMenu, posicaoDoMenu = _f === void 0 ? "below" : _f, permitirMultiplaSelecao = _a.permitirMultiplaSelecao, _g = _a.temMenuTip, temMenuTip = _g === void 0 ? false : _g, _h = _a.opcoesMenu, opcoesMenu = _h === void 0 ? [] : _h, _j = _a.altura, altura = _j === void 0 ? '100%' : _j, _k = _a.largura, largura = _k === void 0 ? '100%' : _k, _l = _a.quebrarLinhas, quebrarLinhas = _l === void 0 ? true : _l, acoes = _a.acoes, _m = _a.esconderTextoExtenso, esconderTextoExtenso = _m === void 0 ? false : _m, _o = _a.valorObrigatorio, valorObrigatorio = _o === void 0 ? false : _o, _p = _a.permitirPesquisa, permitirPesquisa = _p === void 0 ? false : _p, style = _a.style, _q = _a.regraTexto, regraTexto = _q === void 0 ? function (item) { return JSON.stringify(item); } : _q, onSelect = _a.onSelect;
    //#region Variaveis
    var _r = (0, react_1.useState)([]), opcoesDisponiveisMenu = _r[0], setOpcoesDisponiveisMenu = _r[1];
    var _s = (0, react_1.useState)(itensSelecionados || null), selecionados = _s[0], setSelecionados = _s[1];
    var _t = (0, react_1.useState)(''), pesquisa = _t[0], setPesquisa = _t[1];
    var menuVariant = variante === 'error' ? menuModule.error : menuModule.regular;
    var menuPosition = menuModule[posicaoDoMenu] || '';
    var tipDirection = posicaoDoMenu === 'above' ? menuModule['tip-below'] : menuModule['tip-above'];
    var classeTip = temMenuTip ? tipDirection : '';
    //#region Metodos
    var handleOptionClick = function (item) {
        var newSelectedItems;
        if (itensSelecionados === null) {
            setSelecionados([item]);
            onSelect && onSelect([item]);
            return;
        }
        else {
            var itemJaSelecionado = itensSelecionados.includes(item);
            if (permitirMultiplaSelecao) {
                if (itemJaSelecionado) {
                    newSelectedItems = itensSelecionados.filter(function (selectedItem) { return selectedItem !== item; });
                }
                else {
                    newSelectedItems = __spreadArray(__spreadArray([], itensSelecionados, true), [item], false);
                }
            }
            else {
                newSelectedItems = itemJaSelecionado && !valorObrigatorio ? null : [item];
            }
            setSelecionados(newSelectedItems);
            onSelect && onSelect(newSelectedItems);
        }
    };
    var filterMenuOptions = function (searchTerm) {
        searchTerm = searchTerm.trim();
        if (globalMu_1.default.isNullOrEmptyOrUndefined(searchTerm)) {
            return;
        }
        var regex = new RegExp(pesquisa, 'i');
        var filteredOptions = opcoesMenu.filter(function (item) {
            var itemText = regraTexto(item).toLowerCase().match(regex);
            if (itemText) {
                return itemText;
            }
            else {
                return;
            }
        });
        setOpcoesDisponiveisMenu(filteredOptions);
    };
    //#region Componentes
    var MenuHeader = (react_1.default.createElement("div", { className: "".concat(menuModule.menuContent) },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", cor: Cores_1.Cores.TextoDestaque.AzulEscuroMU900, negrito: 700 }, tituloCabecalho),
        react_1.default.createElement("div", { className: menuModule.actions }, acoes)));
    var menuItemList = (react_1.default.createElement("div", { className: "".concat(menuModule.menuItemList) }, opcoesDisponiveisMenu.map(function (item, index) {
        var estaSelecionado = selecionados !== null && selecionados.some(function (selectedItem) { return globalMu_1.default.isDeepEqual(selectedItem, item); });
        return (react_1.default.createElement(MenuItem_1.MenuItem, { key: "".concat(id, "-item-").concat(index), item: item, regraTexto: regraTexto, quebraDeLinha: quebrarLinhas, esconderTextoExtenso: esconderTextoExtenso, estaSelecionado: estaSelecionado, tipo: tipoDoMenu, onClick: function () { return handleOptionClick(item); } }));
    })));
    var barraDePesquisa = (react_1.default.createElement("div", { className: menuModule.barraPesquisa },
        react_1.default.createElement("input", { type: "text", placeholder: "Pesquisar", value: pesquisa, className: menuModule.inputPesquisa, autoFocus: true, onChange: function (e) {
                setPesquisa(e.target.value);
            }, onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === 'NumpadEnter') {
                    filterMenuOptions(pesquisa);
                }
            } }),
        react_1.default.createElement(Botao_1.Botao, { tamanho: "small", tipo: "tipoIconSquare", estilo: "outlined", onClick: function () {
                filterMenuOptions(pesquisa);
            }, style: { padding: '17px' } },
            react_1.default.createElement(Icone_1.Icone, { nome: "search", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }))));
    var tip = react_1.default.createElement("div", { className: "\n            ".concat(classeTip, "\n            ").concat(variante === 'error' ? menuModule.error : '', "\n        ") });
    //#region UseEffects
    (0, react_1.useEffect)(function () {
        if (!globalMu_1.default.isDeepEqual(itensSelecionados, selecionados)) {
            setSelecionados(itensSelecionados);
        }
    }, [itensSelecionados]);
    (0, react_1.useEffect)(function () {
        if (globalMu_1.default.isNullOrEmptyOrUndefined(pesquisa)) {
            setOpcoesDisponiveisMenu(opcoesMenu);
        }
    }, [pesquisa]);
    (0, react_1.useEffect)(function () {
        setOpcoesDisponiveisMenu(opcoesMenu);
    }, [opcoesMenu]);
    return (react_1.default.createElement("div", { className: classes, style: style },
        posicaoDoMenu === 'below' && tip,
        react_1.default.createElement("div", { className: "\n                    ".concat(menuModule.menu, "\n                    ").concat(menuVariant, "\n                    ").concat(menuPosition, "\n                "), style: {
                gap: "".concat(tituloCabecalho || permitirPesquisa ? '8px' : '0'),
                height: altura,
                width: largura
            } },
            tituloCabecalho && MenuHeader,
            permitirPesquisa && barraDePesquisa,
            menuItemList),
        posicaoDoMenu === 'above' && tip));
};
exports.Menu = Menu;
